import {uiMsg} from '../utils/Languages';
import {observable, autorun, computed} from 'mobx';
import * as LoadLevel from './LoadLevel';


// For now this is just a blind copy of the rows from the database.
function createBeaconFromDBRow(row) {
  var b = new Beacon();
  b.id=row.id;
  b.battery=row.battery;
  b.temperature=row.temperature;
  b.room_name=row.name;
  b.last_updated=row.last_updated;
  return b;
}

class Beacon {
  @observable id;
  @observable battery;
  @observable temperature;
  @observable room_name;
  @observable last_updated;
 

  constructor() {
    this.reset();
  }
  reset() {
    this.id=null;
    this.battery=null;
    this.temperature=null;
    this.room_name=null;
    this.last_updated=null;
    
  }


  @computed get readable() {
    return  this.id+" "+this.room_name+" "+this.last_updated+" ";
  }
  
}

// Make utility method available from Class (function)
Beacon.createFromDBRow=createBeaconFromDBRow;

export default Beacon;



/** WEBPACK FOOTER **
 ** ./src/DataModel/Beacon.js
 **/